import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { ThirdPartyLicenses } from 'cpes-common';
import { fetchThirdPartyLicenses } from './ThirdPartyLicensesSlice';
import { ThirdPartyLicensesContentSelector } from './ThirdPartyLicensesContentSelector';

export function useThirdPartyLicenses(): AbstractContentState<ThirdPartyLicenses> {
    return useCmsContent(fetchThirdPartyLicenses, ThirdPartyLicensesContentSelector);
}
